import React from 'react';
import { DebounceInput } from 'react-debounce-input';

const DebounceSearchBar = ({
  value = undefined,
  placeholder,
  onChange,
  onSearch,
}) => (
  <DebounceInput
    className="form-control"
    type="text"
    value={value}
    placeholder={placeholder || 'Search...'}
    style={{ width: '100%', maxWidth: 340, height: 32 }}
    debounceTimeout={200}
    onChange={(e) => {
      if (typeof onChange === 'function') {
        onChange(e);
      }
      setTimeout(() => {
        if (typeof onSearch === 'function') {
          if (e.target) {
            onSearch(e.target.value);
          }
        }
      }, 100);
    }}
  />
);

export default DebounceSearchBar;
